import { render, staticRenderFns } from "./Benchmarks.vue?vue&type=template&id=7f6afe62&"
import script from "./Benchmarks.vue?vue&type=script&lang=js&"
export * from "./Benchmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6afe62')) {
      api.createRecord('7f6afe62', component.options)
    } else {
      api.reload('7f6afe62', component.options)
    }
    module.hot.accept("./Benchmarks.vue?vue&type=template&id=7f6afe62&", function () {
      api.rerender('7f6afe62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/Benchmarks.vue"
export default component.exports